import React, { useContext, useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";

import {
  backIncstance,
  formatDateString,
  getLoginInfo,
} from "../utils/commonFunctions";
import { MyContext } from "../context/MyContext";

//components
import Warning from "./Warning";
import Paging from "./Paging";

//icons
import Copy from "../assets/icons/icon_copy.png";
import Delete from "../assets/icons/icon_del.png";
import styled from "styled-components";

const URLS = {
  CREATE_URL: process.env.REACT_APP_TUTOR_SHARE_LINK,
  GET_URL: process.env.REACT_APP_TUTOR_SHARE_LIST,
  REDIRECT: process.env.REACT_APP_REFERER_URL,
};

const Shared = (props) => {
  const { onClose } = props;
  const { setAlertSetting } = useContext(MyContext);

  const [list, setList] = useState([]);

  const loginInfo = getLoginInfo();

  const [pageInfo, setPageInfo] = useState({
    total: 0,
    offset: 1,
    limit: 5,
  });

  const touchAPI = async (method, url, data) => {
    if (!loginInfo.id) {
      return;
    }

    const response = await backIncstance(method, url, data);
    try {
      if (response.status === 200 || response.status === 201) {
        const resData = await response?.json();
        return resData;
      } else {
      }
    } catch (err) {
      setAlertSetting((prev) => ({
        ...prev,
        alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
        btnTxt: "닫기",
      }));
    } finally {
      // setLoading(false)
    }
  };

  const getData = async () => {
    const data = `?offset=${pageInfo.offset}&limit=${pageInfo.limit}`;
    const resData = await touchAPI("GET", URLS.GET_URL, data);
    if (resData) {
      setList(resData.share_url_list);
      setPageInfo((prev) => ({
        ...prev,
        total: resData.total_count,
        offset: prev.offset,
      }));
    }
  };
  useEffect(() => {
    getData();
  }, [pageInfo.offset]);

  /**
   * warning Handler
   */
  const clearWarnState = () => {
    setWarnSetting({
      ...warnSetting,
      warningTxt: "",
    });
    setIsWarning(false);
  };
  const [isWarning, setIsWarning] = useState(false);
  const [warnSetting, setWarnSetting] = useState({
    warningTxt: "",
    onClose: () => clearWarnState(),
  });
  useEffect(() => {
    if (warnSetting.warningTxt !== "") {
      setIsWarning(true);
    }
  }, [warnSetting.warningTxt]);

  const handleCopy = () => {
    setWarnSetting({
      ...warnSetting,
      warningTxt: "내용이 복사되었습니다.",
    });
  };

  const handleDelete = async (id) => {
    const delData = await touchAPI("DELETE", URLS.CREATE_URL, `?uuid=${id}`);
    if (delData) {
      getData();
    }
  };

  return (
    <Style>
      <div className="modal">
        <div className="modal-content">
          <div className="alert__top">공유 URL 목록</div>
          <div className="alert__middle">
            <div>
              <div className="top flx-box">
                <p className="pad-10">채팅방 이름</p>
                <p className="pad-10">공유 일자</p>
              </div>
              <div className="content">
                {list?.length === 0 ? (
                  <tr>공유한 URL이 없습니다.</tr>
                ) : (
                  list?.map((item) => {
                    return (
                      <div
                        className="flx-box"
                        style={{
                          justifyContent: "space-between",
                        }}
                      >
                        <p className="pad-10 title">{item.title}</p>
                        <div className="flx-box">
                          <p className="pad-10 date">
                            {formatDateString(item.created_at)}
                          </p>
                          <CopyToClipboard
                            text={`${URLS.REDIRECT}/share/${item?.uuid}`}
                            onCopy={handleCopy}
                          >
                            <img
                              className="crs-btn pad-10"
                              src={Copy}
                              alt="copy-url"
                            />
                          </CopyToClipboard>
                          <img
                            className="crs-btn pad-10"
                            src={Delete}
                            alt="delete-url"
                            onClick={() => handleDelete(item?.uuid)}
                          />
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>

            {pageInfo.total > 0 && (
              <Paging pageInfo={pageInfo} setPageInfo={setPageInfo} />
            )}
          </div>
          <div className="alert__bottom">
            <button onClick={onClose} className="crs-btn positive-btn">
              닫기
            </button>
          </div>
        </div>
      </div>
      {isWarning && <Warning settings={warnSetting} />}
    </Style>
  );
};

export default Shared;

const Style = styled.div`
  .modal {
    .alert__top {
      margin-right: auto;
    }
    .alert__middle {
      flex: 1;
      flex-direction: column;
      .top {
        justify-content: space-between;
      }
      .content {
        .title {
          text-overflow: ellipsis;
          max-width: 58%;
          overflow: hidden;
          white-space: nowrap;
        }
        .date {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
  }

  @media screen and (min-width: 1024px) {
    .modal {
      .modal-content {
        width: 600px;
        min-height: 330px;
        height: auto;
        .alert__middle {
          .top {
            p {
              font-size: 17px;
            }
          }
          .content {
            p {
              font-size: 16px;
            }
          }
        }
      }
    }
  }

  @media screen and (min-width: 768.99px) and (max-width: 1023.99px) {
    .modal {
      .modal-content {
        width: 600px;
        min-height: 330px;
        height: auto;
        .top {
          p {
            font-size: 15px;
          }
        }
        .content {
          p {
            font-size: 14px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 768.98px) {
    .modal {
      .modal-content {
        width: 80%;
        min-height: 330px;
        height: auto;
        .top {
          p {
            font-size: 13px;
          }
        }
        .content {
          p {
            font-size: 12px;
          }
        }
      }
    }
  }
`;
